import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import {
  addUser,
  fetchUsers,
  addPerm,
  deletePerm,
  addPassword,
  addEmail,
  addUserName,
  addFirstName,
  addLastName,
  addCurrentUserEmail,
  addCurrentUserPassword,
  addCurrentUserUserName,
  addCurrentUserFirstName,
  addCurrentUserLastName,
  addTwo_factor_authentication,
  add_New_Logo,
  addDisplay_device_logo,
  addCurrentUserPages
} from "signoxe/actions";
import { Box } from "signoxe/components/layout";
import { Button, Popup } from "signoxe/components/widgets";
import { getProfile, getUsers, isFetching } from "signoxe/selectors";
import "./styles.scss";
import { Button, Icon } from "signoxe/components/widgets";

import { Multiselect } from "react-widgets";

import _ from "lodash";

import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

import { actions as notifActions } from "redux-notifications";
import { PLAYLIST_ITEMS_RESOURCE } from "signoxe/api/resources";

const { notifSend } = notifActions;

// ...
const options = [
  { label: "Thing 1", value: 1 },
  { label: "Thing 2", value: 2 },
];

const ListItem = ({ message, id, onDelete }) => (
  <div className="select-item">
    {message} <small onClick={() => onDelete(id)}>x</small>
  </div>
);

class PermissionModal extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    user: PropTypes.object,
    profile: PropTypes.object,
    addPerm: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      keys: [],
      perms: [],
      values: [],
      password: "",
      password1: "",
      email: "",
      email1: "",
      username: "",
      first_name: "",
      last_name: "",
      is_maker: false,
      is_checker: false,
      searchTerm: "",
      pagePerm:false,
      allowedPages: {
        report_page: true,
        tickers_page: true,
        assets_page:true,
        channels_page:true,
        devices_page: true,
        playlist_page:true,
      },

      add_default: false,
    };

    this.getIds = this.getIds.bind(this);

    this.deletePerms = this.deletePerms.bind(this);

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

    this.handlePagePermissionToggle = this.handlePagePermissionToggle.bind(this);


  }

  handleCancel = () => {
    this.props.onCancel();
    this.setState({
      keys: [],
      values: [],
      perms: [],
      password: "",
      password1: "",
      email: "",
      email1: "",
      username: "",
      first_name: "",
      last_name: "",
    });
  };



  createNewUser() {
    if (!this.state.username || !this.state.email) {
      this.props.notifSend({
        message: "User details incomplete.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    } else if (!this.state.password || !this.state.password1) {
      this.props.notifSend({
        message: "Password incomplete.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    } else if (this.state.password !== this.state.password1) {
      this.props.notifSend({
        message: "Passwords do not match.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    } else {
      const allState = {
        username:
          window.localStorage.getItem("alias").replaceAll(" ", "_") +
          "." +
          this.state.username,
        email: this.state.email,
        password: this.state.password,
        is_maker: this.state.is_maker,
        is_checker: this.state.is_checker,
        add_default: false,
      };
      this.props.addUser(allState);
      this.setState({
        password: "",
        password1: "",
        email: "",
        email1: "",
        username: "",
      });
      this.handleCancel();
    }
  }

  savePermKeys() {
    const { id } = this.props.user;
    this.props.addPerm({ id, permissions: this.state.perms });
    this.handleCancel();
  }

  isDisabled(user) {
    if (!user) {
      return;
    }

    const user = this.props.users[this.props.userID];
    const keys = this.getIds(user.permissions);
    const perms = this.state.perms;
    // const ds = _.filter(perms, function(o) { return !keys.includes(o); });

    return user && user.permissions && user.permissions.length === 0;

    // return perms.length === 0 || _.isEqual(perms, keys)
  }

  getIds(arr) {
    return _.map(arr, (value, key) => value.id);
  }

  handleChange(value, metadata) {
    if (!this.props.userID) {
      return;
    }
    const id = this.props.userID;
    const perm_id = metadata.dataItem.id;
    if (metadata.action === "remove") {
      // Call the action state to delete perms.
      this.props.deletePerm({ id, permissions: [perm_id] });
    } else if (metadata.action === "insert") {
      // Call the action state to add perms.
      this.props.addPerm({ id, permissions: [perm_id] });
    }
    // this.setState({perms: this.getIds(value)})
  }

  handleSelectChange(e) {
    const values = Array.from(e.target.selectedOptions, (option) =>
      parseInt(option.value)
    );
    this.setState({ values });
  }

  handleAdd() {
    if (this.state.values.length) {
      const id = this.props.userID;
      this.props.addPerm({ id, permissions: this.state.values });
      this.setState({ values: [] });
    }
  }

  updatePassword() {
    const id = this.props.userID;
    if (
      !this.state.password.length ||
      !this.state.password1.length ||
      this.state.password !== this.state.password1
    ) {
      this.props.notifSend({
        message: "Passwords do not match.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }

    this.props.addPassword({ id, password: this.state.password });
    this.setState({ password: "", password1: "" });
    this.handleCancel();
  }

  updateEmail() {
    const id = this.props.userID;
    if (
      !this.state.email.length ||
      !this.state.email1.length ||
      this.state.email !== this.state.email1
    ) {
      this.props.notifSend({
        message: "email do not match.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }

    this.props.addEmail({ id, email: this.state.email });
    this.setState({ email: "", email1: "" });
    this.handleCancel();
  }

  updateUserName() {
    const id = this.props.userID;
    if (!this.state.username.length) {
      this.props.notifSend({
        message: "Sorry! could not update username.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }

    this.props.addUserName({ id, username: this.state.username });
    this.setState({ username: "" });
    this.handleCancel();
  }

  updateFirstName() {
    const id = this.props.userID;
    if (!this.state.first_name.length) {
      this.props.notifSend({
        message: "Sorry! could not update First Name.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }

    this.props.addFirstName({ id, first_name: this.state.first_name });
    this.setState({ first_name: "" });
    this.handleCancel();
  }

  updateLastName() {
    const id = this.props.userID;
    if (!this.state.last_name.length) {
      this.props.notifSend({
        message: "Sorry! could not update Last Name.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }

    this.props.addLastName({ id, last_name: this.state.last_name });
    this.setState({ last_name: "" });
    this.handleCancel();
  }

  currentUserUpdatePassword() {
    const id = this.props.currentUserserID;
    if (
      !this.state.password.length ||
      !this.state.password1.length ||
      this.state.password !== this.state.password1
    ) {
      this.props.notifSend({
        message: "Passwords do not match.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }

    this.props.addCurrentUserPassword({ id, password: this.state.password });
    this.setState({ password: "", password1: "" });
    this.handleCancel();
  }

  currentUserUpdateEmail() {
    const id = this.props.currentUserserID;
    if (
      !this.state.email.length ||
      !this.state.email1.length ||
      this.state.email !== this.state.email1
    ) {
      this.props.notifSend({
        message: "email do not match.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }

    this.props.addCurrentUserEmail({ id, email: this.state.email });
    this.setState({ email: "", email1: "" });
    this.handleCancel();
  }

  currentUserUpdateUserName() {
    const id = this.props.currentUserserID;
    if (!this.state.username.length) {
      this.props.notifSend({
        message: "Sorry! could not update username.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }

    this.props.addCurrentUserUserName({ id, username: this.state.username });
    this.setState({ username: "" });
    this.handleCancel();
  }

  currentUserUpdateFirstName() {
    const id = this.props.currentUserserID;
    if (!this.state.first_name.length) {
      this.props.notifSend({
        message: "Sorry! could not update First Name.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }

    this.props.addCurrentUserFirstName({
      id,
      first_name: this.state.first_name,
    });
    this.setState({ first_name: "" });
    this.handleCancel();
  }

  currentUserUpdateLastName() {
    const id = this.props.currentUserserID;
    if (!this.state.last_name.length) {
      this.props.notifSend({
        message: "Sorry! could not update Last Name.",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }
    this.props.addCurrentUserLastName({ id, last_name: this.state.last_name });
    this.setState({ last_name: "" });
    this.handleCancel();
  }

  triger_two_factor_authentication() {
    const id = this.props.currentUserserID;
    if (this.props.two_factor_authentication === null) {
      this.props.notifSend({
        message: "Sorry! Could Not Toggle Two Factor Auth",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }
    if (this.props.two_factor_authentication == false) {
      this.props.addTwo_factor_authentication({
        id,
        two_factor_authentication: true,
      });
    } else {
      this.props.addTwo_factor_authentication({
        id,
        two_factor_authentication: false,
      });
    }

    this.handleCancel();
  }

  triger_display_device_logo() {
    const id = this.props.client_id;
    if (this.props.display_device_logo === null) {
      this.props.notifSend({
        message: "Sorry! Could Not Toggle Display Device Logo",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    }
    if (this.props.display_device_logo == false) {
      this.props.addDisplay_device_logo({ id, display_device_logo: true });
    } else {
      this.props.addDisplay_device_logo({ id, display_device_logo: false });
    }

    this.handleCancel();
  }

  add_logo() {
    const id = this.props.client_id;
    if (this.props.newLogo === null) {
      this.props.notifSend({
        message: "Sorry! Could Not add new logo",
        kind: "danger",
        dismissAfter: 3000,
      });
      return;
    } else {
      this.props.add_New_Logo({ id, device_logo: this.props.newLogo });
    }

    this.handleCancel();
  }

  handleCheckboxChange = (page) => {
    this.setState((prevState) => ({
      allowedPages: {
        ...prevState.allowedPages,
        [page]: !prevState.allowedPages[page],
      },
    }));
  };
 
  handlePagePermissionToggle = (user) => {
    console.log("user from toggle", user)
    this.setState({
      allowedPages: {
        report_page: !user.allowed_pages.report_page,
        tickers_page: !user.allowed_pages.tickers_page,
        assets_page: !user.allowed_pages.assets_page,
        channels_page: !user.allowed_pages.channels_page,
        devices_page: !user.allowed_pages.devices_page,
        playlist_page: !user.allowed_pages.playlist_page,
      },
    });
    this.setState({is_checker: user.is_checker})
    this.setState({is_maker: user.is_maker})
    this.setState({pagePerm: !this.state.pagePerm})



  };

  isAnyPageFalse = () => {
    const allowedPages = {
      report_page: true,
      tickers_page: true,
      assets_page: true,
      channels_page: true,
      devices_page: true,
      playlist_page: true,
    };
  
    return Object.values(allowedPages).some(value => value === false);
  };
  
  
  
  handlePagePermission = (id) => {
   const {allowedPages, is_checker, is_maker } = this.state

    const restrictPageAccess = {
      report_page: !allowedPages.report_page,
      tickers_page: !allowedPages.tickers_page,
      assets_page:!allowedPages.assets_page,
      channels_page: !allowedPages.channels_page,
      devices_page: !allowedPages.devices_page,
      playlist_page: !allowedPages.playlist_page,
    }

    this.props.addCurrentUserPages({ id, allowed_pages: restrictPageAccess,
      is_checker:is_checker, is_maker:is_maker
     });
    
  };

  // Filter permissions based on search input

  renderSelectMultiple() {
    const { users, userID, profile } = this.props;
    const { searchTerm } = this.state;

    const user = users[userID];

    const { values } = this.state;

    const pIds = this.getIds(profile.permissions);
    const uIds = this.getIds(user.permissions);
    const perms = _.filter(profile.permissions, (data) => {
      return !uIds.includes(data.id);
    });

    const filteredPerms = _.filter(perms, (value) =>
      value.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
      <div>
      <div className="input-group" style={{ width: "100%", marginTop:"1rem" }}>
        <input
          name="search_term"
          className="input-group-field"
          type="text"
          placeholder="Search Permission"
          onChange={(e) =>
            this.setState({ searchTerm: e.target.value })
          }
        />
        <span
          className="input-group-label cursor"
        >
          <Icon title="search" name="search" size="1rem" />
        </span>
        </div>
        <select
          name="perms"
          className="select-box"
          id="perms"
          value={values}
          onChange={(e) => this.handleSelectChange(e)}
          multiple
        >
          {_.map(filteredPerms, (value, key) => (
            <option key={key} value={value.id}>
              {value.name}
            </option>
          ))}
        </select>
      </div>
    );
  }

  showComponent() {
    const {
      visible,
      onCancel,
      profile,
      createUser,

      reset,
      editMial,
      editUserName,
      editFirstName,
      editLastName,
      user,
      userID,
      users,
      isMakerChecker,
      currentUserReset,
      currentUserEditMial,
      currentUserEditUserName,
      currentUserEditFirstName,
      currentUserEditLastName,
      currentUser,
      currentUserserID,
      two_factor_authentication,
      Toggle_two_factor_authentication,
      display_device_logo,
      Toggle_display_device_logo,
      newLogo,
      Triger_add_logo,
      client_id,
    } = this.props;

    const { password, password1 } = this.state;

    const { email, email1 } = this.state;

    const { username, is_checker, is_maker } = this.state;

    const { first_name } = this.state;

    const { last_name } = this.state;

    const user = users[userID];

    const permissions = user ? user.permission : null;

    const disabled = this.isDisabled(user);



    if (this.props.createUser) {
      return (
        <>
          <h6>Create User</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <label for="txt">
                <input
                  type="text"
                  id="subusername"
                  width="40%"
                  value={window.localStorage.getItem("alias") + "."}
                  disabled
                />
                <input
                  id="txt"
                  type="text"
                  value={username}
                  onChange={(e) => this.setState({ username: e.target.value })}
                  placeholder="Enter Username"
                />
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                placeholder="Re-Enter Email"
              />
              <input
                type="password"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
                placeholder="Enter Password"
              />
              <input
                type="password"
                value={password1}
                onChange={(e) => this.setState({ password1: e.target.value })}
                placeholder="Re-Enter Password"
              />
              {isMakerChecker && (
                <div className="flex flex-ai-c">
                  <label for="is_maker" className="flex flex-ai-c mr-1">
                    <input
                      type="checkbox"
                      id="is_maker"
                      checked={is_maker}
                      onChange={(e) =>
                        this.setState({ is_maker: e.target.checked })
                      }
                    />
                    <p>Is Maker(Asset)</p>
                  </label>

                  <label for="is_checker" className="flex flex-ai-c">
                    <input
                      type="checkbox"
                      id="is_checker"
                      checked={is_checker}
                      onChange={(e) =>
                        this.setState({ is_checker: e.target.checked })
                      }
                    />
                    <p>Is Checker(Asset)</p>
                  </label>
                </div>
              )}
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.createNewUser()}>Create User</Button>
            </Box>
          </Box>
        </>
      );
    }

    if (this.props.reset) {
      return (
        <>
          <h6>Change Password</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <input
                type="password"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
                placeholder="Enter Password"
              />
              <input
                type="password"
                value={password1}
                onChange={(e) => this.setState({ password1: e.target.value })}
                placeholder="Re-Enter Password"
              />
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.updatePassword()}>
                Save Password
              </Button>
            </Box>
          </Box>
        </>
      );
    }

    if (this.props.editMial) {
      return (
        <>
          <h6>Change Mial</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <input
                type="email"
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                placeholder="Enter Email"
              />
              <input
                type="email"
                value={email1}
                onChange={(e) => this.setState({ email1: e.target.value })}
                placeholder="Re-Enter Email"
              />
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.updateEmail()}>Save email</Button>
            </Box>
          </Box>
        </>
      );
    }

    if (this.props.editUserName) {
      return (
        <>
          <h6>Change UserName</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <input
                type="text"
                value={username}
                onChange={(e) => this.setState({ username: e.target.value })}
                placeholder="Enter Username"
              />
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.updateUserName()}>
                Save Username
              </Button>
            </Box>
          </Box>
        </>
      );
    }

    if (this.props.editFirstName) {
      return (
        <>
          <h6>Change First Name</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <input
                type="text"
                value={first_name}
                onChange={(e) => this.setState({ first_name: e.target.value })}
                placeholder="Enter First Name"
              />
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.updateFirstName()}>
                Save First Name
              </Button>
            </Box>
          </Box>
        </>
      );
    }

    if (this.props.editLastName) {
      return (
        <>
          <h6>Change Last Name</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <input
                type="text"
                value={last_name}
                onChange={(e) => this.setState({ last_name: e.target.value })}
                placeholder="Enter Last Name"
              />
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.updateLastName()}>
                Save Last Name
              </Button>
            </Box>
          </Box>
        </>
      );
    }

    if (this.props.currentUserReset) {
      return (
        <>
          <h6>Change Password</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <input
                type="password"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
                placeholder="Enter Password"
              />
              <input
                type="password"
                value={password1}
                onChange={(e) => this.setState({ password1: e.target.value })}
                placeholder="Re-Enter Password"
              />
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.currentUserUpdatePassword()}>
                Save Password
              </Button>
            </Box>
          </Box>
        </>
      );
    }

    if (this.props.currentUserEditMial) {
      return (
        <>
          <h6>Change Mial</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <input
                type="email"
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                placeholder="Enter Email"
              />
              <input
                type="email"
                value={email1}
                onChange={(e) => this.setState({ email1: e.target.value })}
                placeholder="Re-Enter Email"
              />
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.currentUserUpdateEmail()}>
                Save email
              </Button>
            </Box>
          </Box>
        </>
      );
    }

    if (this.props.currentUserEditUserName) {
      return (
        <>
          <h6>Change UserName</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <input
                type="text"
                value={username}
                onChange={(e) => this.setState({ username: e.target.value })}
                placeholder="Enter Username"
              />
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.currentUserUpdateUserName()}>
                Save Username
              </Button>
            </Box>
          </Box>
        </>
      );
    }

    if (this.props.currentUserEditFirstName) {
      return (
        <>
          <h6>Change First Name</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <input
                type="text"
                value={first_name}
                onChange={(e) => this.setState({ first_name: e.target.value })}
                placeholder="Enter First Name"
              />
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.currentUserUpdateFirstName()}>
                Save First Name
              </Button>
            </Box>
          </Box>
        </>
      );
    }

    if (this.props.currentUserEditLastName) {
      
      return (
        <>
          <h6>Change Last Name</h6>
          <Box direction="column" className="actions button-group">
            <form className="password-form">
              <input
                type="text"
                value={last_name}
                onChange={(e) => this.setState({ last_name: e.target.value })}
                placeholder="Enter Last Name"
              />
            </form>
            <Box direction="row" className="actions button-group">
              <Button secondary onClick={() => this.handleCancel()}>
                Exit
              </Button>
              <Button onClick={() => this.currentUserUpdateLastName()}>
                Save Last Name
              </Button>
            </Box>
          </Box>
        </>
      );
    }

    return (
      <>
      <div className="flex flex-jc-se">
      <h6>Edit Permissions</h6>
      <h6 
      onClick={() => this.handlePagePermissionToggle(user)}
      className="cursor"> <Icon title="eye" name={this.state.pagePerm ? "eye-slash": "eye"} size="1rem" /> Page Access</h6>
      </div>
      {!this.state.pagePerm ? <div>
       <div className="multi-select">
          {_.map(permissions, (value, key) => {
            return (
              <ListItem
                key={key}
                message={value.name}
                id={value.id}
                onDelete={this.deletePerms}
              />
            );
          })}
        </div>
        {this.renderSelectMultiple()}

        <Box direction="row" className="actions button-group">
          <Button secondary onClick={() => this.handleCancel()}>
            Exit
          </Button>
          <Button onClick={() => this.handleAdd()}>Add Multiple</Button>
        </Box>
       </div>:
       <div className="multi-select">
      <div>
      <h6>Edit Page Permission</h6>
      <div>
      <label>
          <input
            type="checkbox"
            checked={this.state.allowedPages.assets_page}
            onChange={() => this.handleCheckboxChange('assets_page')}
          />
          Assets Page
        </label>
        <label>
          <input
            type="checkbox"
            checked={this.state.allowedPages.report_page}
            onChange={() => this.handleCheckboxChange('report_page')}
          />
          Report Page
        </label>
        <label>
          <input
            type="checkbox"
            checked={this.state.allowedPages.tickers_page}
            onChange={() => this.handleCheckboxChange('tickers_page')}
          />
          Tickers Page
        </label>
        <label>
          <input
            type="checkbox"
            checked={this.state.allowedPages.channels_page}
            onChange={() => this.handleCheckboxChange('channels_page')}
          />
          Channels Page
        </label>
        <label>
          <input
            type="checkbox"
            checked={this.state.allowedPages.playlist_page}
            onChange={() => this.handleCheckboxChange('playlist_page')}
          />
          Playlist Page
        </label>
      </div>

     {/* {isMakerChecker && <h6>Edit Asset Role</h6>}
      {isMakerChecker && (
                <div className="flex flex-ai-c">
                  <label for="is_maker" className="flex flex-ai-c mr-1">
                    <input
                      type="checkbox"
                      id="is_maker"
                      checked={is_maker}
                      onChange={(e) =>
                        this.setState({ is_maker: e.target.checked })
                      }
                    />
                    <p>Is Maker(Asset)</p>
                  </label>

                  <label for="is_checker" className="flex flex-ai-c">
                    <input
                      type="checkbox"
                      id="is_checker"
                      checked={is_checker}
                      onChange={(e) =>
                        this.setState({ is_checker: e.target.checked })
                      }
                    />
                    <p>Is Checker(Asset)</p>
                  </label>
                </div>
              )} */}
          
        <Box direction="row" className="actions button-group">
          <Button secondary onClick={() => this.handleCancel()}>
            Exit
          </Button>
          <Button disabled={this.isAnyPageFalse()} onClick={() => this.handlePagePermission(this.props.userID)} >Update Permissions</Button>
        </Box>

      </div>
       </div>}
      </>
    );
  }

  deletePerms(perm_id) {
    if (!this.props.userID) {
      return;
    }
    const id = this.props.userID;
    this.props.deletePerm({ id, permissions: [perm_id] });
  }

  render() {
    const {
      createUser,
      isMakerChecker,
      userID,
      currentUserserID,
      currentUser,
      users,
      user,
      visible,
      onCancel,
      profile,
      reset,
      editMial,
      editUserName,
      editFirstName,
      editLastName,
      currentUserReset,
      currentUserEditMial,
      currentUserEditUserName,
      currentUserEditFirstName,
      currentUserEditLastName,
    } = this.props;

    if (users[userID]) {
      const disabled = this.isDisabled(user);
      const permissions = user ? user.permissions : null;
      const plug = users[userID];
      if (visible) {
        return (
          <Popup
            className="permission-popup"
            title={`Edit User Detail For "${plug.username}"`}
            modal
          >
            <Box
              className="modal-wrapper"
              direction="column"
              justifyContent="center"
            >
              {this.showComponent()}
            </Box>
          </Popup>
        );
      } else {
        return null;
      }
    } else if (
      Object.keys(currentUser).length &&
      currentUser[currentUserserID]
    ) {
      if (visible) {
        return (
          <Popup
            className="permission-popup"
            title={`Edit User Detail For "${currentUser[currentUserserID].username}"`}
            modal
          >
            <Box
              className="modal-wrapper"
              direction="column"
              justifyContent="center"
            >
              {this.showComponent()}
            </Box>
          </Popup>
        );
      } else if (this.props.Toggle_two_factor_authentication === true) {
        return <>{this.triger_two_factor_authentication()}</>;
      } else {
        return null;
      }
    } else if (createUser) {
      if (visible) {
        return (
          <Popup className="permission-popup" title={`Create New User`} modal>
            <Box
              className="modal-wrapper"
              direction="column"
              justifyContent="center"
            >
              {this.showComponent()}
            </Box>
          </Popup>
        );
      } else {
        return null;
      }
    } else if (this.props.client_id !== null || undefined) {
      if (this.props.Toggle_display_device_logo === true) {
        return <>{this.triger_display_device_logo()}</>;
      } else if (this.props.Triger_add_logo === true) {
        return <>{this.add_logo()}</>;
      }
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    profile: getProfile(state),
  };
};

export default connect(mapStateToProps, {
  addUser,

  addEmail,
  addPerm,
  deletePerm,
  addPassword,
  addUserName,
  addFirstName,
  addLastName,

  addCurrentUserEmail,
  addCurrentUserPassword,
  addCurrentUserUserName,
  addCurrentUserFirstName,
  addCurrentUserLastName,
  addTwo_factor_authentication,
  addDisplay_device_logo,
  add_New_Logo,
  notifSend,
  addCurrentUserPages
})(PermissionModal);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/PermissionModal/index.js